/**
 * receiver_emails is a Postgres text[] and comes back from the API as an array.
 * The config form edits it as a list of chips (see RecipientEmailsInput), but we
 * still normalize free-text/pasted input and legacy comma-strings into an array,
 * so these helpers bridge the shapes and validate addresses at a single place.
 */
import { z } from 'zod';

const emailSchema = z.email();

export function isValidEmail(email) {
    return emailSchema.safeParse((email || '').trim()).success;
}

/** Normalize an array or delimited string into trimmed, non-empty emails. */
export function parseReceiverEmails(value) {
    const list = Array.isArray(value) ? value : (value || '').split(/[\s,;]+/);
    return list.map((email) => email.trim()).filter(Boolean);
}

/** Return the entries that are not valid emails. */
export function findInvalidEmails(value) {
    return parseReceiverEmails(value).filter((email) => !isValidEmail(email));
}

/** Render receiver_emails as a single comma-separated string for a text input. */
export function formatReceiverEmails(value) {
    return parseReceiverEmails(value).join(', ');
}
